import { RuleId } from '@wix/a11y-rules';
import { DEFAULT_BRANCH_ID } from '@wix/a11y-wizard-common';
import { createRuleData } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/http';
import { RuleAction } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/types';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { useCallback } from 'react';
import { SITE_LEVEL_PAGE_ID } from '../../consts';
import { useSessionInfoContext } from '../../hooks/use-session-info-context';
export const useUpdateSiteLanguageRuleData = () => {
  const httpClient = useHttpClient();
  const {
    withErrorHandler
  } = useErrorHandler();
  const {
    branchId
  } = useSessionInfoContext();
  const createSiteLanguageRuleData = useCallback(() => withErrorHandler(async () => httpClient.request(createRuleData({
    ruleData: {
      branchId: branchId || DEFAULT_BRANCH_ID,
      pageId: SITE_LEVEL_PAGE_ID,
      ruleAction: RuleAction.COMPLETED_MANUALLY,
      ruleId: RuleId.SITE_LANGUAGE
    }
  })), {
    errorCodesMap: {}
  }), [branchId, httpClient, withErrorHandler]);
  return {
    createSiteLanguageRuleData
  };
};
//# sourceMappingURL=use-update-site-language-rule-data.js.map